import Vue from 'vue';
import Vuetify from 'vuetify';
import 'vuetify/dist/vuetify.min.css';
import { preset } from 'vue-cli-plugin-vuetify-preset-owl/preset';
import '../styles/main.scss';

Vue.use(Vuetify);

export default new Vuetify({
  preset,
  theme: {
    themes: {
      light: {
        primary: '#3A4BE4',
        secondary: '#D44B9D',
        accent: '#FFD25C',
        error: '#FF5252',
        info: '#2196F3',
        success: '#4CAF50',
        warning: '#FFC107',
      },
    },
  },
});
